import { render, staticRenderFns } from "./PaymentError.vue?vue&type=template&id=457cc1a4&scoped=true&"
import script from "./PaymentError.vue?vue&type=script&lang=js&"
export * from "./PaymentError.vue?vue&type=script&lang=js&"
import style0 from "./PaymentError.vue?vue&type=style&index=0&id=457cc1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457cc1a4",
  null
  
)

export default component.exports